// Shared between the Service Worker (`sw.ts`) and the client registration code in
// `service-worker-init.tsx`. The tag identifies the Periodic Background Sync that
// refreshes the unread-notifications app icon badge while the app is closed
// (Chromium only).
export const PERIODIC_BADGE_SYNC_TAG = 'refresh-notification-badge';

// Delay (ms) between clearing and re-setting the badge in `flushAppBadge`. Edge only
// flushes the taskbar badge overlay to the OS on a navigation; toggling the badge off
// then back on nudges a repaint without a reload. Kept short so the flicker is barely
// perceptible while still giving Edge a separate paint tick.
export const BADGE_FLUSH_NUDGE_DELAY_MS = 60;

// Requested minimum interval between periodic syncs. The browser ultimately
// controls the actual cadence.
export const PERIODIC_BADGE_SYNC_MIN_INTERVAL_MS = 12 * 60 * 60 * 1000;

// Message type the Service Worker posts to window clients after refreshing the
// badge on an incoming push, so the foreground app can refetch the unread count
// immediately (keeping the in-app bell indicator and icon badge in sync while
// open). Shared between `sw.ts` and the client (`notifications-context.tsx`).
export const BADGE_REFRESH_MESSAGE_TYPE = 'badge-refresh';

// Interval (ms) at which the foreground app polls the unread notifications count
// while the document is visible. Keeps the badge fresh on platforms without
// Periodic Background Sync (e.g. iOS) without draining battery when backgrounded.
export const UNREAD_COUNT_POLL_INTERVAL_MS = 60 * 1000;

// Message type a window client posts to the Service Worker to ask it to (re)apply the
// unread-notifications app icon badge from the worker context. On Edge the taskbar
// badge only repaints on a navigation when set from the window context, so foreground
// updates (60s poll, reload, mark-as-read, opening the dropdown) delegate to the SW,
// which reliably repaints without a navigation (the same context the push path uses).
// The message carries the current unread `count` so the SW can apply it directly
// without an extra unread-count fetch. Shared between `notifications-context.tsx` and
// `sw.ts`.
export const REQUEST_BADGE_REFRESH_MESSAGE_TYPE = 'request-badge-refresh';

// Message type a window client posts to the Service Worker to close all currently
// displayed (tray) notifications. Used to clear the Android launcher icon dot once
// the in-app unread count reaches 0 — on Android the dot is driven by tray
// notifications (Badging API unsupported), so closing them is the only way to clear
// it when the user has read everything. Shared between `notifications-context.tsx`
// and `sw.ts`.
export const CLOSE_ALL_NOTIFICATIONS_MESSAGE_TYPE = 'close-all-notifications';
